import {
  AdultSpecies,
  PetSpeciesID,
  petSpeciesTuple,
} from '../../pet/pet.ruleset';

export type SpeciesType =
  | 'happy'
  | 'normal'
  | 'sad'
  | 'verysad'
  | 'dying'
  | 'dead'
  | 'ascension';
type InviteType = 'invite' | 'invite/ultimate';
export const speciesChatbot = petSpeciesTuple;

export type SpeciesChatbotType = (typeof speciesChatbot)[number];
export type Species =
  | `species/${SpeciesChatbotType}/${SpeciesType}`
  | `species/${AdultSpecies}/${InviteType}`;

export const getPetAssetKey = (
  species: SpeciesChatbotType,
  type: SpeciesType = 'normal',
): Species => `species/${species}/${type}`;

export const speciesAssets: Record<Species, string> = {
  // Ball
  ...createSpeciesAssets('ball'),

  // Crab
  ...createSpeciesAssets('crab'),

  // Dog
  ...createSpeciesAssets('dog'),

  // Starball
  ...createSpeciesAssets('starball'),

  // Hamster
  ...createSpeciesAssets('hamster'),

  // Turtle
  ...createSpeciesAssets('turtle'),

  // Squirrel
  ...createSpeciesAssets('squirrel'),

  // Seaotter
  ...createSpeciesAssets('seaotter'),

  // Cat
  ...createSpeciesAssets('cat'),

  // Fish
  ...createSpeciesAssets('fish'),

  // Pig
  ...createSpeciesAssets('pig'),

  // Bear
  ...createSpeciesAssets('bear'),

  // Penguin
  ...createSpeciesAssets('penguin'),

  // Adults

  // Whale
  ...createAdultSpeciesAssets('whale'),

  // Giraffe
  ...createAdultSpeciesAssets('giraffe'),

  // Dino
  ...createAdultSpeciesAssets('dinosaur'),

  // Pinkdog
  ...createAdultSpeciesAssets('pinkdog'),

  // Panda
  ...createAdultSpeciesAssets('panda'),

  // Lion
  ...createAdultSpeciesAssets('lion'),

  // Elephant
  ...createAdultSpeciesAssets('elephant'),

  // Reindeer
  ...createAdultSpeciesAssets('reindeer'),

  // Polarbear
  ...createAdultSpeciesAssets('polarbear'),

  // Alpaca
  ...createAdultSpeciesAssets('alpaca'),

  // Tiger
  ...createAdultSpeciesAssets('tiger'),

  // Sealion
  ...createAdultSpeciesAssets('sealion'),

  // Flamingo
  ...createAdultSpeciesAssets('flamingo'),

  // Cow
  ...createAdultSpeciesAssets('cow'),

  // Persian cat
  ...createAdultSpeciesAssets('persiancat'),

  // Dolphin
  ...createAdultSpeciesAssets('dolphin'),
};

/**
 * Pets images scaling ratio
 */
export const speciesAssetsRatio: Record<Species, `${number}:${number}`> = {
  // Ball
  'species/ball/happy': '348:331',
  'species/ball/normal': '1.04:1',
  'species/ball/sad': '1.03:1',
  'species/ball/verysad': '1.01:1',
  'species/ball/dying': '1:1.20',
  'species/ball/dead': '700:565',
  'species/ball/ascension': '700:1028',

  // Crab
  'species/crab/happy': '470:326',
  'species/crab/normal': '1.21:1',
  'species/crab/sad': '1.20:1',
  'species/crab/verysad': '1.20:1',
  'species/crab/dying': '1.07:1',
  'species/crab/dead': '1000:805',
  'species/crab/ascension': '700:871',

  // Dog
  'species/dog/happy': '450:346',
  'species/dog/normal': '1.06:1',
  'species/dog/sad': '1:1.04',
  'species/dog/verysad': '1.06:1',
  'species/dog/dying': '1:1.17',
  'species/dog/dead': '700:606',
  'species/dog/ascension': '700:1012',

  // Starball
  'species/starball/happy': '308:297',
  'species/starball/normal': '1.05:1',
  'species/starball/sad': '1.03:1',
  'species/starball/verysad': '1:1',
  'species/starball/dying': '1:1.09',
  'species/starball/dead': '700:675',
  'species/starball/ascension': '700:1086',

  // Hamster
  'species/hamster/happy': '338:285',
  'species/hamster/normal': '1.08:1',
  'species/hamster/sad': '1.07:1',
  'species/hamster/verysad': '1.06:1',
  'species/hamster/dying': '1:1.24',
  'species/hamster/dead': '700:636',
  'species/hamster/ascension': '700:1104',

  // Turtle
  'species/turtle/happy': '377:317',
  'species/turtle/normal': '1.06:1',
  'species/turtle/sad': '1:1',
  'species/turtle/verysad': '1:1',
  'species/turtle/dying': '1:1.13',
  'species/turtle/dead': '700:684',
  'species/turtle/ascension': '700:1008',

  // Squirrel
  'species/squirrel/happy': '275:202',
  'species/squirrel/normal': '287:193',
  'species/squirrel/sad': '289:209',
  'species/squirrel/verysad': '277:184',
  'species/squirrel/dying': '314:243',
  'species/squirrel/dead': '700:470',
  'species/squirrel/ascension': '700:1152',

  // Seaotter
  'species/seaotter/happy': '330:330',
  'species/seaotter/normal': '1.01:1',
  'species/seaotter/sad': '1:1.04',
  'species/seaotter/verysad': '1:1.04',
  'species/seaotter/dying': '1:1.22',
  'species/seaotter/dead': '700:680',
  'species/seaotter/ascension': '700:1289',

  // Cat
  'species/cat/happy': '384:342',
  'species/cat/normal': '1:1.06',
  'species/cat/sad': '1:1.03',
  'species/cat/verysad': '1:1.04',
  'species/cat/dying': '1:1.23',
  'species/cat/dead': '700:735',
  'species/cat/ascension': '700:1111',

  // Fish
  'species/fish/happy': '246:204',
  'species/fish/normal': '246:218',
  'species/fish/sad': '216:202',
  'species/fish/verysad': '238:214',
  'species/fish/dying': '224:281',
  'species/fish/dead': '700:584',
  'species/fish/ascension': '700:971',

  // Pig
  'species/pig/happy': '280:207',
  'species/pig/normal': '214:199',
  'species/pig/sad': '222:205',
  'species/pig/verysad': '216:200',
  'species/pig/dying': '236:278',
  'species/pig/dead': '700:647',
  'species/pig/ascension': '700:1126',

  // Bear
  'species/bear/happy': '203:199',
  'species/bear/normal': '185:198',
  'species/bear/sad': '202:216',
  'species/bear/verysad': '195:212',
  'species/bear/dying': '205:271',
  'species/bear/dead': '700:717',
  'species/bear/ascension': '700:1061',

  // Penguin
  'species/penguin/happy': '235:190',
  'species/penguin/normal': '198:203',
  'species/penguin/sad': '215:200',
  'species/penguin/verysad': '208:206',
  'species/penguin/dying': '247:275',
  'species/penguin/dead': '700:705',
  'species/penguin/ascension': '700:1227',

  // Adults

  // Whale
  'species/whale/happy': '339:323',
  'species/whale/normal': '285:268',
  'species/whale/sad': '286:213',
  'species/whale/verysad': '285:323',
  'species/whale/dying': '230:297',
  'species/whale/invite': '387:485',
  'species/whale/invite/ultimate': '387:485',
  'species/whale/dead': '700:663',
  'species/whale/ascension': '700:909',

  // Giraffe
  'species/giraffe/happy': '271:331',
  'species/giraffe/normal': '256:347',
  'species/giraffe/sad': '259:315',
  'species/giraffe/verysad': '259:350',
  'species/giraffe/dying': '205:303',
  'species/giraffe/invite': '286:562',
  'species/giraffe/invite/ultimate': '286:562',
  'species/giraffe/dead': '700:996',
  'species/giraffe/ascension': '700:1229',

  // Dinosaur
  'species/dinosaur/happy': '220:209',
  'species/dinosaur/normal': '221:215',
  'species/dinosaur/sad': '214:211',
  'species/dinosaur/verysad': '206:212',
  'species/dinosaur/dying': '226:278',
  'species/dinosaur/invite': '305:562',
  'species/dinosaur/invite/ultimate': '305:562',
  'species/dinosaur/dead': '700:689',
  'species/dinosaur/ascension': '700:989',

  // Pinkdog
  'species/pinkdog/happy': '188:184',
  'species/pinkdog/normal': '188:186',
  'species/pinkdog/sad': '195:203',
  'species/pinkdog/verysad': '192:193',
  'species/pinkdog/dying': '188:241',
  'species/pinkdog/invite': '353:408',
  'species/pinkdog/invite/ultimate': '353:403',
  'species/pinkdog/dead': '700:703',
  'species/pinkdog/ascension': '700:1103',

  // Panda
  'species/panda/happy': '230:195',
  'species/panda/normal': '195:209',
  'species/panda/sad': '198:202',
  'species/panda/verysad': '190:203',
  'species/panda/dying': '205:262',
  'species/panda/invite': '390:510',
  'species/panda/invite/ultimate': '390:515',
  'species/panda/dead': '700:722',
  'species/panda/ascension': '700:1120',

  // Lion
  'species/lion/happy': '228:196',
  'species/lion/normal': '228:196',
  'species/lion/sad': '224:201',
  'species/lion/verysad': '221:195',
  'species/lion/dying': '242:253',
  'species/lion/invite': '374:449',
  'species/lion/invite/ultimate': '374:446',
  'species/lion/dead': '700:774',
  'species/lion/ascension': '700:922',

  // Elephant
  'species/elephant/happy': '293:206',
  'species/elephant/normal': '293:186',
  'species/elephant/sad': '251:191',
  'species/elephant/verysad': '227:193',
  'species/elephant/dying': '328:235',
  'species/elephant/invite': '459:404',
  'species/elephant/invite/ultimate': '459:413',
  'species/elephant/dead': '700:496',
  'species/elephant/ascension': '700:886',

  // Reindeer
  'species/reindeer/happy': '190:209',
  'species/reindeer/normal': '158:209',
  'species/reindeer/sad': '165:219',
  'species/reindeer/verysad': '169:225',
  'species/reindeer/dying': '337:268',
  'species/reindeer/invite': '298:523',
  'species/reindeer/invite/ultimate': '298:522',
  'species/reindeer/dead': '1000:1237',
  'species/reindeer/ascension': '700:959',

  // Polarbear
  'species/polarbear/happy': '212:210',
  'species/polarbear/normal': '184:205',
  'species/polarbear/sad': '176:197',
  'species/polarbear/verysad': '180:201',
  'species/polarbear/dying': '206:248',
  'species/polarbear/invite': '376:485',
  'species/polarbear/invite/ultimate': '376:492',
  'species/polarbear/dead': '700:806',
  'species/polarbear/ascension': '700:1089',

  // Alpaca
  'species/alpaca/happy': '163:220',
  'species/alpaca/normal': '171:206',
  'species/alpaca/sad': '160:218',
  'species/alpaca/verysad': '216:200',
  'species/alpaca/dying': '206:303',
  'species/alpaca/invite': '284:488',
  'species/alpaca/invite/ultimate': '284:481',
  'species/alpaca/dead': '700:1780',
  'species/alpaca/ascension': '700:1103',

  // Tiger
  'species/tiger/happy': '196:182',
  'species/tiger/normal': '175:187',
  'species/tiger/sad': '202:202',
  'species/tiger/verysad': '183:192',
  'species/tiger/dying': '300:208',
  'species/tiger/invite': '364:486',
  'species/tiger/invite/ultimate': '364:492',
  'species/tiger/dead': '700:719',
  'species/tiger/ascension': '700:1088',

  // Sealion
  'species/sealion/happy': '183:194',
  'species/sealion/normal': '173:196',
  'species/sealion/sad': '206:192',
  'species/sealion/verysad': '208:178',
  'species/sealion/dying': '190:228',
  'species/sealion/dead': '700:813',
  'species/sealion/ascension': '700:1201',

  // Flamingo
  'species/flamingo/happy': '188:216',
  'species/flamingo/normal': '188:216',
  'species/flamingo/sad': '204:215',
  'species/flamingo/verysad': '202:209',
  'species/flamingo/dying': '264:242',
  'species/flamingo/invite': '314:539',
  'species/flamingo/invite/ultimate': '314:546',
  'species/flamingo/dead': '700:778',
  'species/flamingo/ascension': '700:1079',

  // Cow
  'species/cow/happy': '192:210',
  'species/cow/normal': '192:205',
  'species/cow/sad': '194:208',
  'species/cow/verysad': '185:203',
  'species/cow/dying': '291:251',
  'species/cow/invite': '304:482',
  'species/cow/invite/ultimate': '312:482',
  'species/cow/dead': '700:745',
  'species/cow/ascension': '700:1067',

  // Persian cat
  'species/persiancat/happy': '186:201',
  'species/persiancat/normal': '186:201',
  'species/persiancat/sad': '199:215',
  'species/persiancat/verysad': '197:212',
  'species/persiancat/dying': '259:246',
  'species/persiancat/invite': '341:489',
  'species/persiancat/invite/ultimate': '341:485',
  'species/persiancat/dead': '700:722',
  'species/persiancat/ascension': '700:1062',

  // Dolphin
  'species/dolphin/happy': '218:195',
  'species/dolphin/normal': '223:193',
  'species/dolphin/sad': '230:202',
  'species/dolphin/verysad': '216:194',
  'species/dolphin/dying': '218:232',
  'species/dolphin/invite': '381:486',
  'species/dolphin/invite/ultimate': '382:486',
  'species/dolphin/dead': '700:615',
  'species/dolphin/ascension': '700:946',
};

function createSpeciesAssets<T extends PetSpeciesID>(species: T) {
  return {
    [`species/${species}/happy`]: `private/chatbot/species/${species}/happy.png`,
    [`species/${species}/normal`]: `private/chatbot/species/${species}/normal.png`,
    [`species/${species}/sad`]: `private/chatbot/species/${species}/sad.png`,
    [`species/${species}/verysad`]: `private/chatbot/species/${species}/verysad.png`,
    [`species/${species}/dying`]: `private/chatbot/species/${species}/dying.png`,
    [`species/${species}/dead`]: `private/chatbot/species/${species}/dead.png`,
    [`species/${species}/ascension`]: `private/chatbot/species/${species}/ascension.png`,
  } as Record<`species/${T}/${SpeciesType}`, string>;
}

function createAdultSpeciesAssets<T extends PetSpeciesID>(species: T) {
  return {
    [`species/${species}/happy`]: `private/chatbot/species/${species}/happy.png`,
    [`species/${species}/normal`]: `private/chatbot/species/${species}/normal.png`,
    [`species/${species}/sad`]: `private/chatbot/species/${species}/sad.png`,
    [`species/${species}/verysad`]: `private/chatbot/species/${species}/verysad.png`,
    [`species/${species}/dying`]: `private/chatbot/species/${species}/dying.png`,
    [`species/${species}/invite`]: `private/chatbot/species/${species}/invite.png`,
    [`species/${species}/invite/ultimate`]: `private/chatbot/species/${species}/invite_ultimate.png`,
    [`species/${species}/dead`]: `private/chatbot/species/${species}/dead.png`,
    [`species/${species}/ascension`]: `private/chatbot/species/${species}/ascension.png`,
  } as Record<`species/${T}/${SpeciesType | InviteType}`, string>;
}
